var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('div',{staticClass:"row flex-nowrap"},[_c('navbar'),_c('div',{staticClass:"col py-3"},[_c('router-view',{staticClass:"debug1"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }